export default __webpack_public_path__ + "static/media/blueEditIcon.47b44a6c.svg";